export default () => {
    $( "#scrollTop" ).on("click", function() {
        $("html, body").animate({ scrollTop: 0 }, 600);
    })

    $(document).on('scroll', function() {
        var y = $(this).scrollTop();
        if (y > 12) {
            $('#stickynav').fadeIn();
            $('#stickynav').css('display', 'fixed')
        }
    });

    $('#scrollnext').on('click', function() {
        const menu = $('header').height();
        let target = menu+2
        $("html, body").animate({ scrollTop: target}, 600);
    })
}